import { type DropTargetDropEvent, useDropTarget } from '@pique/component';
import type { AffineDNDData } from '@pique/core/types/dnd';
import { useI18n } from '@pique/i18n';

import { EmptyNodeChildren } from '../../layouts/empty-node-children';

export const Empty = ({
  onDrop,
}: {
  onDrop: (data: DropTargetDropEvent<AffineDNDData>) => void;
}) => {
  const { dropTargetRef } = useDropTarget<AffineDNDData>(
    () => ({
      onDrop,
    }),
    [onDrop]
  );
  const t = useI18n();

  return (
    <EmptyNodeChildren ref={dropTargetRef}>
      {t['com.pique.rootAppSidebar.docs.no-subdoc']()}
    </EmptyNodeChildren>
  );
};
